import { axiosDS } from '@pp/axios'
import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Constants/Urls'
import { OrdersApiLog } from 'Pages/logs'
import { Id } from 'Src/types/aliases'

export const ordersApiLogsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<OrdersApiLog>>(urls.logs.orders_api, {
			params,
		})
		return res.data
	},
	resendByExternalRequestId: async (external_request_id: Id) => {
		const res = await axiosDS().post<{ result: 'ok' }>(urls.logs.resend_by_external_request_id, {
			external_request_id,
		})
		return res.data
	},
}
